var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.17,
    height: 23.26,
    viewBox: "0 0 24.17 23.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f05353;\n      }\n\n      .cls-2 {\n        fill: #383838;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3672",
    "data-name": "Group 3672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16638",
    "data-name": "Path 16638",
    className: "cls-1",
    d: "M15.35,10.87a1.79,1.79,0,0,1-1.19.46,1.7,1.7,0,0,1-.87-.24,1.79,1.79,0,0,1-1.15.8,4.85,4.85,0,0,1,1.43,3.6H12.38a3.48,3.48,0,0,0-1.26-2.93,3.88,3.88,0,0,0-.72-.47L9.3,13.47l-.93-.74L9.77,11l.16-.22h1.86a.6.6,0,0,0,.62-.57.61.61,0,0,0-.57-.62H9.67c-.47.45-.91.92-1.33,1.41l-.87,1.15-.1.13a2.64,2.64,0,0,0-.31.71V13s0,.05,0,.06a1.35,1.35,0,0,0,.35,1L8.8,15.67a2.94,2.94,0,0,0,2.23,1h3.13a3,3,0,0,0,3-3h0V11.22a1.71,1.71,0,0,1-.59.11A1.81,1.81,0,0,1,15.35,10.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16639",
    "data-name": "Path 16639",
    className: "cls-1",
    d: "M14.16,10.15a.6.6,0,0,0,.6-.58V7.77a.6.6,0,1,0-1.19,0V9.55a.59.59,0,0,0,.57.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16640",
    "data-name": "Path 16640",
    className: "cls-1",
    d: "M12.38,8.48V7.18a.6.6,0,0,0-.59-.6.62.62,0,0,0-.6.6V8.36h.6A1.72,1.72,0,0,1,12.38,8.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16641",
    "data-name": "Path 16641",
    className: "cls-1",
    d: "M9,8.53l.16-.17H10V7.77a.59.59,0,0,0-.6-.59.58.58,0,0,0-.59.59v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16642",
    "data-name": "Path 16642",
    className: "cls-2",
    d: "M21.15,0H3A3,3,0,0,0,0,3H0V20.24a3,3,0,0,0,3,3H21.15a3,3,0,0,0,3-3h0V3a3,3,0,0,0-3-3ZM18.32,13.71a4.15,4.15,0,0,1-4.16,4.15H11a4.13,4.13,0,0,1-3.12-1.4L6.5,14.85a2.59,2.59,0,0,1-.63-2.1s0-.08,0-.13a2.49,2.49,0,0,1,.48-1.09l.19-.24a11.38,11.38,0,0,1,.85-1.12L7.56,10l.07-.1V7.77A1.79,1.79,0,0,1,9.41,6a1.71,1.71,0,0,1,.88.24,1.76,1.76,0,0,1,3,0A1.7,1.7,0,0,1,14.16,6a1.76,1.76,0,0,1,1.5.83,1.82,1.82,0,0,1,.88-.24,1.79,1.79,0,0,1,1.78,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16643",
    "data-name": "Path 16643",
    className: "cls-1",
    d: "M16.54,7.77a.57.57,0,0,0-.59.57s0,0,0,0V9.55a.59.59,0,0,0,1.18,0V8.37a.57.57,0,0,0-.56-.6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStr);
export default __webpack_public_path__ + "static/media/STR.0a56fdcadd6db6f7f707854e798baf12.svg";
export { ForwardRef as ReactComponent };